import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { url_reverse } from "@components/Utils";

export default function LandingBlockGameEditScreen() {
    const { t } = useTranslation();
    const { slug, selection_id, block_id, selection_item_id } = useParams();
    const apiUrl = url_reverse("api:landing:block:edit_game", { selection_id, block_id, selection_item_id });
    const { apiData } = useAppApi(apiUrl);
    const backUrl = url_reverse("admin:event:landing_block:games", { slug, selection_id, block_id });

    if (!apiData) return;

    const header = (
        <>
            <Link to={backUrl}>{t("Игры блока")}</Link>
            <span> – </span>
            {apiData.block_name}
            <span> – </span>
            <Link to={url_reverse("games:admin", { game_id: apiData.game.game_id, locale: apiData.game.locale })}>
                {apiData.game.name}
            </Link>
        </>
    );
    return (
        <DefaultLayout>
            <Card>
                <Card.Header>{header}</Card.Header>
                <Card.Body>
                    <RenderForm backUrl={backUrl} />
                </Card.Body>
            </Card>
        </DefaultLayout>
    );
}
